import React from 'react';
import PropTypes from 'prop-types';
import Icon from "components/Icon";
import cn from 'classnames';
import './InvestorFinancialEvent.scss';

const InvestorFinancialEvent = ({ title, day, month, date, time, metaDate, metaTime, isHighlighted }) => {
    return (
        <div className="investor-financial-event">
            <div className={cn("investor-financial-event__date-box", {
                "investor-financial-event__date-box_highlighted": isHighlighted
            })}>
                <span className="investor-financial-event__day">{day}</span>
                <span className="investor-financial-event__month">{month}</span>
            </div>
            <div className="investor-financial-event__info">
                {title && (
                    <div className="investor-financial-event__title-holder">
                        <span className="investor-financial-event__title">{title}</span>
                        {/* <Icon icon="calendar-add" className="investor-financial-event__title-icon" /> */}
                    </div>
                )}
                <time dateTime={metaDate} className="investor-financial-event__date">
                    {date}
                </time>
                <time dateTime={metaTime} className="investor-financial-event__date">
                    {time}
                </time>
            </div>
        </div>
    );
};

InvestorFinancialEvent.propTypes = {
    title: PropTypes.string,
    day: PropTypes.string,
    month: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    metaDate: PropTypes.string,
    metaTime: PropTypes.string,
    isHighlighted: PropTypes.bool // FE only
};

export default InvestorFinancialEvent;


// WEBPACK FOOTER //
// ./src/components/InvestorFinancialEvent/InvestorFinancialEvent.jsx